import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProyectosService } from '../proyectos.service'
import { HttpClient, HttpClientModule } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})

export class AnalysisServiceService {

  constructor(public proyectoService: ProyectosService,){
  }

  private englishTypeSource = new BehaviorSubject<string>('british');
  currentEnglishType = this.englishTypeSource.asObservable();

  private analysisModeSource = new BehaviorSubject<string>('Writing');
  currentAnalysisMode = this.analysisModeSource.asObservable();

  private targetCEFRSource = new BehaviorSubject<string>('A1');
  currentTargetCEFR = this.targetCEFRSource.asObservable();

  private achiveCEFRSource = new BehaviorSubject<string>('C2');
  currentAchiveCEFR = this.achiveCEFRSource.asObservable();

  private excludeDigitsSource = new BehaviorSubject<boolean>(true);
  currentExcludeDigits = this.excludeDigitsSource.asObservable();

  private useKnownWordsSource = new BehaviorSubject<boolean>(true);
  currentUseKnownWords = this.useKnownWordsSource.asObservable();

  private splitCharacterSource = new BehaviorSubject<string>('');
  currentSplitCharacter = this.splitCharacterSource.asObservable();

  private wordlistSelect = new BehaviorSubject<any>(null); // Inicializa con null
  currentWordlist = this.wordlistSelect.asObservable();

  private wordlistCreatedSource = new Subject<any>();
  wordlistCreated$ = this.wordlistCreatedSource.asObservable();


  private cleanValue(value: string): string {
    return value.replace(/\u200b/g, ''); // Elimina caracteres invisibles (\u200b)
  }

changeEnglishType(type: string) {
    this.englishTypeSource.next(this.cleanValue(type));
  }

  changeAnalysisMode(mode: string) {
    this.analysisModeSource.next(this.cleanValue(mode));
  }

  changeTargetCEFR(score: string) {
    this.targetCEFRSource.next(this.cleanValue(score));
  }

  changeSplitCharacter(value: string) {
    this.splitCharacterSource.next(value);
  }

  changeAchiveCEFR(score: string) {
    this.achiveCEFRSource.next(score);
  }

  changeExcludeDigits(value: boolean) {
    this.excludeDigitsSource.next(value);
  }

  changeUseKnownWords(value: boolean) {
    this.useKnownWordsSource.next(value);
  }

   // Nueva función para cambiar el wordlist
   changeWordlist(value: string | null) {
    this.wordlistSelect.next(value);
  }

  notifyWordlistCreated(value: any) {
    this.wordlistCreatedSource.next(value);
  }



  public limpiarMarcado(): void {
    this.proyectoService.undoMarcadoMultiple2();
  }
}
